import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Flex, Heading, Text, Grid } from '@chakra-ui/core';

import Button from '../../helpers/Button';
import FarmCard from '../../Farms/FarmCard';

const StartFarm = ({ farms, menuOpen, setSession, setUnexpectedError, fetchActivities }) => {
  const history = useHistory();

  return (
    <Box bg="cf.200" px={{ lg: 48 }} py={16} pl={{ base: 14, md: 20 }} pr={{ base: 4, md: 5 }}>
      <Flex wrap="wrap" justify="space-between" align="center">
        <Box>
          <Heading as="h4">
            Here's what happened on your <br className="hidden md:block lg:hidden" />
            farm last week
          </Heading>
          <Text color="cf.400">click to view farm</Text>
        </Box>

        <Box d={{ base: 'none', md: 'block' }}>
          <Button
            click={() => history.push('/start-farm')}
            name="Start A New Farm"
            className="text-white bg-cf-300 px-3 py-4 shadow-sm rounded focus:outline-none"
          />
        </Box>
      </Flex>

      <Grid
        // templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        // px={{ base: 2, md: 0 }}
        className="grid grid-cols-1 md:grid-cols-2 md:gap-4 md:col-gap-6 px-2 md:px-0"
      >
        {farms &&
          farms.map(farm => (
            <FarmCard
              key={farm._id}
              data={farm}
              setSession={setSession}
              setUnexpectedError={setUnexpectedError}
              fetchActivities={fetchActivities}
            />
          ))}
      </Grid>
    </Box>
  );
};

export default StartFarm;
